import { useState } from 'react';
import createStore from 'ctx-provider';
import { cloneDeep, isEqual } from 'lodash';
import { DEFAULT_EXCHANGE, DEFAULT_EXCHANGE_KEY, EXCHANGES } from 'config/constants';

const useExchange = () => {
	const [exchange, setExchangeObject] = useState(DEFAULT_EXCHANGE && cloneDeep(DEFAULT_EXCHANGE));
	const [exchangeKey, setExchangeKey] = useState(DEFAULT_EXCHANGE_KEY);

	const setExchange = key => {
		const newExchangeObject = EXCHANGES[key];
		if (!isEqual(newExchangeObject, exchange)) {
			setExchangeObject(cloneDeep(newExchangeObject));
			setExchangeKey(key);
		}
	};

	return {
		exchange,
		exchangeKey,
		setExchange,
	};
};

const store = createStore(useExchange);

export const { Provider } = store;
export default store.ctx;
